<template>
  <div
    class="body-status"
    :class="validColorBack()"
  >
    <div
      class="circle"
      :class="validColorCircle()"
    >
      <template v-if="pendingOrDeclined">
        <img
          :src="require('@/assets/icons/warning.svg')"
          alt="payment status"
        >
      </template>
      <template v-if="authorized">
        <img
          :src="require('@/assets/icons/shape.svg')"
          alt="payment status"
        >
      </template>
    </div>
    <span :class="validColorFont()">
      <template v-if="validString === 'Authorised'">
        Payment Processed
      </template>
      <template v-else>
        {{validString}}
      </template>
    </span>
  </div>
</template>
<script>
export default {
  name: 'payment-status',
  props: {
    status: String,
  },

  methods: {
    validColorBack() {
      // TODOS STATUS
      // DECLINED, PREAUTHORIZED, CAPTURED, BATCHED, REVERSED
      // [ test system ] AUTHORISED
      // const statusTiny = this.formatStatusForTiny(this.status);
      let color = '';
      if (this.formatStatusForTiny(this.status).indexOf('authorised') !== -1) {
        color = 'back-green';
      }
      if (this.formatStatusForTiny(this.status).indexOf('pending') !== -1) {
        color = 'back-yellow';
      }
      if (this.formatStatusForTiny(this.status).indexOf('declined') !== -1) {
        color = 'back-red';
      }
      if (color === '') {
        color = 'back-other';
      }
      return color;
    },
    validColorCircle() {
      let color = '';
      if (this.formatStatusForTiny(this.status).indexOf('authorised') !== -1) {
        color = 'circle-green';
      }
      if (this.formatStatusForTiny(this.status).indexOf('pending') !== -1) {
        color = 'circle-yellow';
      }
      if (this.formatStatusForTiny(this.status).indexOf('declined') !== -1) {
        color = 'circle-red';
      }
      if (color === '') {
        color = 'circle-other';
      }
      return color;
    },
    validColorFont() {
      let color = '';
      if (this.formatStatusForTiny(this.status).indexOf('authorised') !== -1) {
        color = 'font-green';
      }
      if (this.formatStatusForTiny(this.status).indexOf('pending') !== -1) {
        color = 'font-yellow';
      }
      if (this.formatStatusForTiny(this.status).indexOf('declined') !== -1) {
        color = 'font-red';
      }
      if (color === '') {
        color = 'font-other';
      }
      return color;
    },
    formatStatusForTiny(word) {
      return word.toLowerCase();
    },
    formatWord(word) {
      const finalWord = word.toLowerCase().replace(/(?:^|\s)\S/g, a => a.toUpperCase());
      return finalWord;
    },
  },
  computed: {
    pendingOrDeclined() {
      return this.formatStatusForTiny(this.status).indexOf('pending') !== -1 || this.status.indexOf('declined') !== -1;
    },
    authorized() {
      return this.formatStatusForTiny(this.status).indexOf('authorised') !== -1;
    },
    validString() {
      let capitalize = '';
      if (this.status.indexOf('test system') !== -1) {
        const statusFormated = this.status.slice(15);
        capitalize = this.formatWord(statusFormated);
        return capitalize.trim();
      }
      capitalize = this.formatWord(this.status);
      return capitalize.trim();
    },
  },
};
</script>
<style lang="scss" scoped>
.body-status {
  display: flex;
  align-items: center;
  min-height: 30px;
  padding: 0 10px 0 4px;
  border-radius: 17.5896px;
  white-space: wrap;
  .circle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    border-radius: 11px;
    margin-right: 5px;
  }
}
.back-red {
  background-color: $backgroundDeclined;
}
.back-green {
  background-color: $backgroundPayed;
}
.back-yellow {
  background-color: $backgroundToPay;
}
.back-other {
  background-color: $disabled;
}

.circle-red {
  background-color: $declined;
}
.circle-green {
  background-color: $payed;
}
.circle-yellow {
  background-color: $toPay;
}
.circle-other {
  background-color: $disabled;
}

.font-red {
  color: $declined;
}
.font-green {
  color: $payed;
}
.font-yellow {
  color: $toPay;
}
.font-other {
  color: $disabled;
}
</style>
